import {UserRoles} from "../enums/general-enums";

export const FreePlan = {
  roleDB: UserRoles.freemium,
  role: 'Lister',
  planId: 'free',
  amount: 'Free',
  offer: ['Ads'],
  offerWhenActivePlan: ['Ads'],
  offerWhenSinglePlanView: ['Ads'],
  btnText: 'Stay free forever',
  btnTextWhenActivePlan: '',
  btnTextSinglePlan: 'Stay free forever'

};

export const AListerPlan = {
  roleDB: UserRoles.aLister,
  role: 'A-Lister',
  planId: 'tlalister',
  amount: '1.99$',
  offer: ['No Ads'],
  offerWhenActivePlan: ['No Ads'],
  offerWhenSinglePlanView: ['No Ads'],
  btnText: 'Upgrade to A-Lister plan',
  btnTextWhenActivePlan: 'Cancel A-Lister plan',
  btnTextSinglePlan: 'Upgrade to A-Lister'
};

export const AListerMobilePlan = {
  roleDB: UserRoles.aLister,
  role: 'A-Lister',
  planId: 'tlalister-mobile',
  amount: '1.99$',
  offer: ['No Ads'],
  offerWhenActivePlan: ['No Ads'],
  offerWhenSinglePlanView: ['No Ads'],
  btnText: 'Upgrade to A-Lister plan',
  btnTextWhenActivePlan: '',
  btnTextSinglePlan: 'Upgrade to A-Lister'
};

export const ExpertPlan = {
  roleDB: UserRoles.expert,
  role: 'Expert',
  planId: 'tlexpert',
  amount: '10.99$',
  offer: ['No Ads', 'Sponsored Lists', 'Recommended Lists'],
  offerWhenActivePlan: ['No Ads', 'Insights', 'Reviews'],
  offerWhenSinglePlanView: ['No Ads', 'Sponsored Lists', 'Recommended Lists', 'Up to 50 Private Lists'],
  btnText: 'Upgrade to Expert plan',
  btnTextWhenActivePlan: 'Cancel Expert plan',
  btnTextSinglePlan: 'Upgrade to premium'
};

export const ExpertMobilePlan = {
  roleDB: UserRoles.expert,
  role: 'Expert',
  planId: 'tlexpert-mobile',
  amount: '10.99$',
  offer: ['No Ads', 'Sponsored Lists', 'Recommended Lists'],
  offerWhenActivePlan: ['No Ads', 'Insights', 'Reviews'],
  offerWhenSinglePlanView: ['No Ads', 'Sponsored Lists', 'Recommended Lists', 'Up to 50 Private Lists'],
  btnText: 'Upgrade to Expert plan',
  btnTextWhenActivePlan: '',
  btnTextSinglePlan: 'Upgrade to premium'
};

export const CompanyPlan = {
  roleDB: UserRoles.company,
  role: 'Company',
  planId: 'tlpartner',
  amount: '39.99$$',
  offerWhenActivePlan: ['No Ads', 'Sponsored Lists', 'Recommended Lists', 'Up to 50 Private Lists'],
  offerWhenSinglePlanView: ['No Ads', 'Sponsored Lists', 'Recommended Lists', 'Up to 50 Private Lists'],
  btnText: 'Upgrade to Company plan',
  btnTextWhenActivePlan: 'Cancel Company plan',
  btnTextSinglePlan: 'Upgrade to premium'
};

export const CompanyMobilePlan = {
  roleDB: UserRoles.company,
  role: 'Company',
  planId: 'tlpartner-mobile',
  amount: '39.99$$',
  offerWhenActivePlan: ['No Ads', 'Sponsored Lists', 'Recommended Lists', 'Up to 50 Private Lists'],
  offerWhenSinglePlanView: ['No Ads', 'Sponsored Lists', 'Recommended Lists', 'Up to 50 Private Lists'],
  btnText: 'Upgrade to Company plan',
  btnTextWhenActivePlan: '',
  btnTextSinglePlan: 'Upgrade to premium'
};
